/**
 * Back in stock ("Notify me when available") — front end only.
 *
 * Buttons rendered by snippets/notify-when-available-button.liquid carry the
 * product/variant context in data-* attributes. Clicking one opens the shared
 * modal (snippets/notify-when-available-modal.liquid) and, on submit, POSTs the
 * signup as JSON to the endpoint configured in Theme settings > Back in stock.
 *
 * Expected endpoint contract (see BACK-IN-STOCK-BACKEND.md):
 *   POST <endpoint>
 *   Content-Type: application/json
 *   Body: { shop, product_id, variant_id, product_handle, email, phone, channel, locale }
 *   Success: HTTP 2xx (any JSON body).
 */
(function () {
  'use strict';

  var modal = document.getElementById('NotifyWhenAvailableModal');
  if (!modal) return;

  var form = modal.querySelector('[data-notify-form]');
  var statusEl = modal.querySelector('[data-notify-status]');
  var submitBtn = modal.querySelector('[data-notify-submit]');
  var endpoint = modal.getAttribute('data-endpoint') || '';
  var shop = modal.getAttribute('data-shop') || '';

  var fields = {
    productId: modal.querySelector('[data-notify-product-id]'),
    variantId: modal.querySelector('[data-notify-variant-id]'),
    productHandle: modal.querySelector('[data-notify-product-handle]'),
    productTitle: modal.querySelector('[data-notify-product-title]'),
    variantTitle: modal.querySelector('[data-notify-variant-title]'),
  };

  function setStatus(message, state) {
    if (!statusEl) return;
    statusEl.textContent = message || '';
    if (state) {
      statusEl.setAttribute('data-state', state);
    } else {
      statusEl.removeAttribute('data-state');
    }
  }

  function openModal(button) {
    // Reset previous state.
    setStatus('', null);
    if (form) form.reset();

    var data = button.dataset;
    if (fields.productId) fields.productId.value = data.productId || '';
    if (fields.variantId) fields.variantId.value = data.variantId || '';
    if (fields.productHandle) fields.productHandle.value = data.productHandle || '';
    if (fields.productTitle) fields.productTitle.textContent = data.productTitle || '';
    if (fields.variantTitle) {
      // Hide the variant line for single-variant products ("Default Title").
      var vt = data.variantTitle || '';
      fields.variantTitle.textContent = vt === 'Default Title' ? '' : vt;
    }

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  }

  function closeModal() {
    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
  }

  // Open — event delegation so it also works for cards injected later
  // (e.g. infinite scroll on collection pages).
  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-notify-open]');
    if (openTrigger) {
      // Prevent the surrounding product-card link from navigating.
      event.preventDefault();
      event.stopPropagation();
      openModal(openTrigger);
      return;
    }
    if (event.target.closest('[data-notify-close]')) {
      closeModal();
      return;
    }
    // Click on the backdrop (the dialog element itself) closes it.
    if (event.target === modal) {
      closeModal();
    }
  }, true); // capture phase: run before the product card's own click handler

  if (!form) return;

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    if (!endpoint) {
      setStatus('Notifications are not configured yet. Please try again later.', 'error');
      return;
    }

    var emailInput = form.querySelector('[name="email"]');
    var phoneInput = form.querySelector('[name="phone"]');
    var email = emailInput ? emailInput.value.trim() : '';
    var phone = phoneInput ? phoneInput.value.trim() : '';

    if (!email) {
      setStatus('Please enter a valid email address.', 'error');
      return;
    }

    var payload = {
      shop: shop,
      product_id: fields.productId ? fields.productId.value : '',
      variant_id: fields.variantId ? fields.variantId.value : '',
      product_handle: fields.productHandle ? fields.productHandle.value : '',
      email: email,
      phone: phone,
      channel: phone ? 'email_sms' : 'email',
      locale: document.documentElement.lang || '',
    };

    submitBtn.disabled = true;
    setStatus('Submitting…', null);

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed: ' + response.status);
        return response.json().catch(function () {
          return {};
        });
      })
      .then(function () {
        setStatus("You're on the list — we'll email you when it's back.", 'success');
        form.reset();
        setTimeout(closeModal, 2000);
      })
      .catch(function () {
        setStatus('Something went wrong. Please try again.', 'error');
      })
      .finally(function () {
        submitBtn.disabled = false;
      });
  });
})();
